import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface MenuProperties {
  svgIcon?: JSX.Element;
  label?: string;
  key: string;
  isActive: boolean;
}

interface ToggleWithIconsProperties {
  leftMenu: MenuProperties;
  rightMenu: MenuProperties;
  handleClickToggle: (key: string) => void;
  disabled?: boolean;
}

/**
 * Shared component -> Handle toggle button with left and right icons
 * @returns
 */
function ToggleWithIcons(properties: ToggleWithIconsProperties) {
  const { t } = useTranslation('dashboard');
  const { leftMenu, rightMenu, handleClickToggle, disabled } = properties;
  const [toggleActive, setToggleActive] = useState<string>();

  /**
   * Function toggle the arrow to point left or right
   */
  const handleToggle = () => {
    if (leftMenu.isActive) {
      handleClickToggle(rightMenu.key);
    } else {
      handleClickToggle(leftMenu.key);
    }
  };

  useEffect(() => {
    if (leftMenu.isActive) {
      setToggleActive('left');
    } else {
      setToggleActive('right');
    }
  }, [leftMenu, rightMenu]);

  return (
    <div className="toggle-with-icons-wrap">
      <div className={`toggle-icon-container ${toggleActive === 'left' && 'active'}`}>
        {leftMenu?.svgIcon && (
          <div className={`toggle-icon ${toggleActive === 'left' && 'active'}`}>
            {leftMenu?.svgIcon}
          </div>
        )}
        {t(`${leftMenu?.label}`)}
      </div>
      <div className="toggle-container">
        <div
          className={`toggle-btn ${disabled ? 'disabled' : ''}`}
          role="presentation"
          onClick={() => {
            if (!disabled) handleToggle();
          }}>
          <div className={`toggle-circle ${toggleActive}`}>
            <span>
              <svg
                width="4"
                height="8"
                viewBox="0 0 4 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0.399912 3.24496L1.38491 2.25996L2.98991 0.654963C3.32991 0.319963 3.90991 0.559963 3.90991 1.03996V4.15496V6.95996C3.90991 7.43996 3.32991 7.67996 2.98991 7.33996L0.399912 4.74996C-0.0150881 4.33996 -0.0150881 3.65996 0.399912 3.24496Z"
                  fill="#292D32"
                />
              </svg>
            </span>
          </div>
        </div>
      </div>
      <div className={`toggle-icon-container ${toggleActive === 'right' && 'active'}`}>
        {rightMenu?.svgIcon && (
          <div className={`toggle-icon ${toggleActive === 'right' && 'active'}`}>
            {rightMenu?.svgIcon}
          </div>
        )}
        {t(`${rightMenu?.label}`)}
      </div>
    </div>
  );
}

export default ToggleWithIcons;
